import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
import { getMimeType } from '../../../../helpers/common';
import { mimeTypes as constMimeTypes } from '../../../../config';

const banners = (state) => state.banners.list;
const dimensions = (state) => state.banners.dimensions;
const mimeTypes = (state) => state.banners.mimeTypes;

export const getBanners = createSelector(
    banners,
    (banners = []) => {
        return banners;
    }
);

export const getBannersGallery = createSelector(
    banners,
    (banners = []) => {
        let vertical = [];
        let horizontal = [];
        let square = [];

        const push = (item, array, proportion) => {
            array.push({
                ...item,
                proportion,
                type: getMimeType(item.mime_type),
                small: item.width < 120
            });
        };

        banners.forEach(item => {
            let ratio =  item.width / item.height;

            if (ratio > 1.3 && item.width > 250) {
                push(item, horizontal, 'horizontal');
            } else if (ratio < 0.7) {
                push(item, vertical, 'vertical');
            } else {
                push(item, square, 'square');
            }
        });

        square.sort((a, b) => {
            return a.width - b.width && a.height - b.height;
        });
        horizontal.sort((a, b) => {
            return b.width - a.width;
        });
        vertical.sort((a, b) => {
            return a.height - b.height;
        });

        return horizontal.concat(square, vertical);
    }
);

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            '№',
            staticNames.name,
            staticNames.type,
            staticNames.size,
            staticNames.action
        ];
    }
);

export const getDimensions = createSelector(
    dimensions,
    (dimensions = []) => {
        return dimensions.map(size => {
            return {
                title: size,
                value: size
            };
        });
    }
);

export const getMimeTypes = createSelector(
    mimeTypes,
    (mimeTypes = []) => {
        let list = [];
        let staticKeys = [];

        mimeTypes.map((item) => {
            if (item in constMimeTypes) {
                list.push({
                    value: item,
                    title: constMimeTypes[item]
                });
            } else {
                staticKeys.push(item);
            }
        });

        list.push({
            value: staticKeys.join(','),
            title: 'Static'
        });

        return list;
    }
);

export const getProportions = createSelector(
    () => {
        const proportions = UserStore.getTranslation().proportions;
        let list = [];

        for (let key in proportions) {
            list.push({
                value: key,
                title: proportions[key]
            });
        }

        return list;
    }
);
